export default [
  { type: "car", alias: ["auto", "car"] },
  { type: "motorbike", alias: ["moto", "motorbike"] }
];



// WEBPACK FOOTER //
// ./src/stores/vehicleInformationStore/data/vehicleTypes.js